import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da pesquisa das áreas */
export class AreaFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    situacoes: number[] = [];;

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Situação
        this.situacoes?.forEach(situacao => {
            params = params.append('situacao', situacao.toString());
        });

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.situacoes = [];
    }
}

